import styled from 'styled-components';
import { VehicleOptions, NoImagePlaceholder } from '../../../../../components';
import { ImagePreview } from '..';
import { useSalesOfferAuction } from '../hooks';
import { useSelector } from 'react-redux';
import { NegotiationLabel } from '../../../../../components/NegotiationLabel';
import { useBidsOfferAuction } from '../../../../Buyer/BidsList/components/hooks';
import { useIsAlternativeAuction } from '../../../../../hooks';
import { ReserveLabel } from '../../../../../components/ReserveLabel';

const DetailsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media only screen and (max-width: 768px) {
    width: 95%;
  }
`;

const ImagePreviewWrapper = styled.div`
  position: relative;
`;

const ImageBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const OrderIndexWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #757575;
  font-size: 12px;
`;

const OrderIndex = styled.div`
  background: #b0b0b04d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  width: 32px;
`;

export const VehicleOptionsBlock = ({ currentVehicle, includeOrderIndex = false }) => {
  const user = useSelector(state => state.user.user);
  const hookByUserType = {
    buyer: useBidsOfferAuction,
    seller: useSalesOfferAuction
  };

  const useOfferAuction = hookByUserType[user.role];
  const offerAuction = useOfferAuction(currentVehicle.id);

  const isAlternativeAuction = useIsAlternativeAuction(currentVehicle);
  const showReserveLabel = isAlternativeAuction && user.role === 'seller';

  const imageSrc = currentVehicle.preview_image?.url_thumb;

  return (
    <DetailsWrapper>
      <ImageBlock>
        <ImagePreviewWrapper>
          {imageSrc ? <ImagePreview vehicleId={currentVehicle.id} url={imageSrc} /> : <NoImagePlaceholder />}
          <NegotiationLabel vehicle={currentVehicle} offerAuction={offerAuction} user={user} position="bottom" />
          {showReserveLabel && <ReserveLabel item={currentVehicle} />}
        </ImagePreviewWrapper>

        {includeOrderIndex && (
          <OrderIndexWrapper>
            <span>Vehicle #</span>
            <OrderIndex>
              <span>{currentVehicle.orderIndex}</span>
            </OrderIndex>
          </OrderIndexWrapper>
        )}
      </ImageBlock>

      <VehicleOptions currentVehicle={currentVehicle} />
    </DetailsWrapper>
  );
};
